export function getVehicles() {
  return {
    type: 'GET_VEHICLES',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/vehicles/getVehicles',
            mock: false,
          },
        },
        commit: {
          type: 'GET_VEHICLES_COMMIT',
        },
      },
    },
  }
}

export function setVehicle(vehicle) {
  return {
    type: 'SET_VEHICLE',
    payload: { vehicle },
  }
}
